import { app } from '../../../app';
import { Controller } from './header.controller';

app.component('userPublicUserAccountsHeader', {
    bindings: {account: '<'},
    controller: Controller,
    templateUrl: require('./header.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/header.component.js